
      // Dynamic price table on product page + lowest price + delivery date on all cards (full calc – matches calculator)
      document.addEventListener('DOMContentLoaded', () => {
        const mfGlobal = window.productMetafields || {};

        // Table on product page
        const tableContainer = document.getElementById('dynamic-price-table');
        if (tableContainer) {
          const mf = mfGlobal;
          const qtyBreaks = mf.quantity_breaks || [];
          const basePrices = mf.base_prices || [];

          if (qtyBreaks.length > 0) {
            let tableHTML = '<table class="price-table"><thead><tr><th>Branding</th>';
            qtyBreaks.forEach(q => tableHTML += `<th>${q}</th>`);
            tableHTML += '</tr></thead><tbody>';

            const decoTypes = [
              { key: '1_colour_print', name: '1 Colour', setupKey: '1_colour_set_up_cost' },
              { key: '2_colour_print', name: '2 Colour', setupKey: '2_colour_set_up_cost' },
              { key: '3_colour_print', name: '3 Colour', setupKey: '3_colour_set_up_cost' },
              { key: '4_colour_print', name: '4 Colour', setupKey: '4_colour_set_up_cost' },
              { key: 'full_colour_print', name: 'Full Colour', setupKey: 'full_colour_set_up_cost' },
              { key: 'embroidery_cost', name: 'Embroidered', setupKey: 'embroidery_set_up_cost' },
              { key: 'laser_engrave_costs', name: 'Laser Engraved', setupKey: 'laser_set_up_cost' }
            ];

            const carriagePrices = mf.carriage || [];

            decoTypes.forEach(deco => {
              const prices = mf[deco.key] || [];
              if (prices.every(p => p === 0)) return;

              tableHTML += `<tr><td>${deco.name}</td>`;
              qtyBreaks.forEach((qtyStr, i) => {
                const qty = parseInt(qtyStr, 10) || 0;
                if (qty === 0) {
                  tableHTML += '<td>-</td>';
                  return;
                }

                const base = parseFloat(basePrices[i]) || 0;
                const addOn = parseFloat(prices[i]) || 0;
                const unitPreFixed = base + addOn;
                const baseCost = qty * unitPreFixed;

                const setup = parseFloat(mf[deco.setupKey]) || 0;

                const carriage = parseFloat(carriagePrices[i]) || 0;

                const baseCostFixed = baseCost + setup + carriage;

                let markup = 0;
                if (baseCostFixed < 144) {
                  markup = 50;
                } else if (baseCostFixed < 350) {
                  markup = baseCostFixed * 0.35;
                } else if (baseCostFixed < 1000) {
                  markup = baseCostFixed * 0.30;
                } else if (baseCostFixed < 2500) {
                  markup = baseCostFixed * 0.28;
                } else {
                  markup = baseCostFixed * 0.25;
                }

                const total = baseCostFixed + markup;
                const unitPrice = Math.round((total / qty) * 100) / 100;

                tableHTML += `<td>£${unitPrice.toFixed(2)}</td>`;
              });
              tableHTML += '</tr>';
            });

            tableHTML += '</tbody></table>';
            tableContainer.innerHTML = tableHTML;
          }
        }
      });



      // Dynamic lowest price + delivery date on product cards
window.addEventListener('load', () => {
  const cardSelector = '.product-card, .recommended-product, .product-item, .grid__item, .related-product';
  const deliveryDateCache = {};

  const processSingleCard = async (card) => {
    if (!card || card.dataset.kaboomPricingDone === 'true') return;

    const jsonEl = card.querySelector('.card-metafields-json');
    if (!jsonEl) return;

    card.dataset.kaboomPricingDone = 'true';

    const mf = JSON.parse(jsonEl.textContent);

    const qtyBreaks = mf.quantity_breaks || [];
    const basePrices = mf.base_prices || [];

    if (qtyBreaks.length > 0 && basePrices.length > 0) {
      const highestIndex = qtyBreaks.length - 1;
      const qty = parseInt(qtyBreaks[highestIndex], 10) || 0;

      if (qty > 0) {
        const base = parseFloat(basePrices[highestIndex]) || 0;

        const decoFallbacks = [
          { key: '1_colour_print', setupKey: '1_colour_set_up_cost' },
          { key: '2_colour_print', setupKey: '2_colour_set_up_cost' },
          { key: '3_colour_print', setupKey: '3_colour_set_up_cost' },
          { key: '4_colour_print', setupKey: '4_colour_set_up_cost' },
          { key: 'full_colour_print', setupKey: 'full_colour_set_up_cost' },
          { key: 'laser_engrave_costs', setupKey: 'laser_set_up_cost' },
          { key: 'embroidery_cost', setupKey: 'embroidery_set_up_cost' }
        ];

        let addOn = 0;
        let setup = 0;

        for (const deco of decoFallbacks) {
          const addOnPrices = mf[deco.key] || [];
          const priceIndex = Math.min(highestIndex, addOnPrices.length - 1);

          if (priceIndex >= 0 && parseFloat(addOnPrices[priceIndex]) > 0) {
            addOn = parseFloat(addOnPrices[priceIndex]) || 0;
            setup = parseFloat(mf[deco.setupKey]) || 0;
            break;
          }
        }

        const unitPreFixed = base + addOn;
        const baseCost = qty * unitPreFixed;

        const carriagePrices = mf.carriage || [];
        const carriage = parseFloat(carriagePrices[highestIndex]) || 0;

        const baseCostFixed = baseCost + setup + carriage;

        let markup = 0;
        if (baseCostFixed < 144) {
          markup = 50;
        } else if (baseCostFixed < 350) {
          markup = baseCostFixed * 0.35;
        } else if (baseCostFixed < 1000) {
          markup = baseCostFixed * 0.30;
        } else if (baseCostFixed < 2500) {
          markup = baseCostFixed * 0.28;
        } else {
          markup = baseCostFixed * 0.25;
        }

        const total = baseCostFixed + markup;
        const unitPrice = Math.round((total / qty) * 100) / 100;

        const priceEl = card.querySelector('.from-price');
        if (priceEl) {
          priceEl.innerHTML = `From <strong>£${unitPrice.toFixed(2)}</strong> each`;
        }
      }
    }

    const leadTimeRaw = mf.lead_time || 'Not selected';
    const leadTimeStr = Array.isArray(leadTimeRaw) ? leadTimeRaw[0] : leadTimeRaw;

    let deliveryDate = 'Calculating...';

    try {
      if (deliveryDateCache[leadTimeStr]) {
        deliveryDate = deliveryDateCache[leadTimeStr];
      } else {
        deliveryDate = await calculateDeliveryDate(leadTimeStr);
        deliveryDateCache[leadTimeStr] = deliveryDate;
      }
    } catch (e) {
      deliveryDate = 'Unavailable';
    }

    const deliveryEl = card.querySelector('.delivery-date');
    if (deliveryEl) {
      deliveryEl.textContent = deliveryDate;
    }
  };

  const processCards = async () => {
    const cards = Array.from(document.querySelectorAll(cardSelector))
      .sort((a, b) => {
        const aRect = a.getBoundingClientRect();
        const bRect = b.getBoundingClientRect();

        if (Math.round(aRect.top) !== Math.round(bRect.top)) {
          return aRect.top - bRect.top;
        }

        return aRect.left - bRect.left;
      });

    const batchSize = window.innerWidth < 768 ? 3 : 8;

for (let i = 0; i < cards.length; i += batchSize) {
  const batch = cards.slice(i, i + batchSize);

  await Promise.all(batch.map(card => processSingleCard(card)));

  await new Promise(resolve => setTimeout(resolve, 50));
}
  };

  processCards();

  let retries = 0;
  const interval = setInterval(() => {
    processCards();
    retries++;
    if (retries >= 5) clearInterval(interval);
  }, 1000);
});
